import Request from "./request";

export default class ProductService {
  static async getList(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Product/user/getList",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }


  static async findById(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Product/user/findById",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async updateById(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Product/updateById",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async deleteById(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Product/deleteById",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async advanceUserCreate(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Product/advanceUser/create",
        data: data,
        query: null,
      }).then((result = {}) => {
        return resolve(result);
      });
    });
  }

  static async advanceUserGetList(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Product/advanceUser/getList",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(result);
        }
      });
    });
  }

  static async advanceUserUpdateBy(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Product/advanceUser/updateById",
        data: data,
        query: null,
      }).then((result = {}) => {
        return resolve(result);
      });
    });
  }

  static async advanceUserDeleteBy(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/Product/advanceUser/deleteById",
        data: data,
        query: null,
      }).then((result = {}) => {
        return resolve(result);
      });
    });
  }

  // ProductCategory APIs
  static async categoryFind(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/ProductCategory/find",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(data);
        }
      });
    });
  }

  static async categoryAdvanceUserGetList(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/ProductCategory/advanceUser/getList",
        data: { ...data },
        query: null,
      }).then((result = {}) => {
        const { statusCode, data } = result;
        if (statusCode === 200) {
          return resolve(data);
        } else {
          return resolve(result);
        }
      });
    });
  }

  static async categoryAdvanceUserCreate(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/ProductCategory/advanceUser/create",
        data: data,
        query: null,
      }).then((result = {}) => {
        return resolve(result);
      });
    });
  }

  static async categoryAdvanceUserUpdateBy(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/ProductCategory/advanceUser/updateById",
        data: data,
        query: null,
      }).then((result = {}) => {
        return resolve(result);
      });
    });
  }

  static async categoryAdvanceUserDeleteBy(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/ProductCategory/advanceUser/deleteById",
        data: data,
        query: null,
      }).then((result = {}) => {
        return resolve(result);
      });
    });
  }
}
